import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, CategoryScale } from 'chart.js';
import '../../styles/DonutChart.css';

ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale);

const DonutChart = (props) => {
    // Data for the chart
    const data = {
        labels: ['Total Enquiries', 'Total Registered Students', 'Total Enrolled Students'],
        datasets: [
            {
                label: 'Student Data',
                data: [1, 2, 8],
                // backgroundColor: ['#36A2EB', '#FF6384', '#FFCE56'], // Colors for the chart slices
                backgroundColor: ['#bbb6df', '#b08ea2', '#3e517a'], 
                hoverOffset: 4, // The effect of enlarging the slices when hovered over
            },
        ],
    };

    // Options for the chart to make it interactive and eye-catching
    const options = {
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.label}: ${tooltipItem.raw}`;
                    },
                },
            },
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 14, // Font size for the legend labels
                        weight: 'bold', // Font weight for the legend labels
                    },
                },
            },
            title: {
                display: true,
                text: 'Student Enrollment Overview',
                font: {
                    size: 18,
                    weight: 'bold',
                    family: 'Arial, sans-serif',
                },
            },
        },
    };

    // Check if apiData is available before using it
    const totalEnquiries = props.apiData?.total_enquiries || 0;
    const totalRegisteredStudents = props.apiData?.total_registered_students || 0;
    const totalEnrolledStudents = props.apiData?.total_enrolled_students || 0;

    if (!totalEnquiries) {
        return <div>Loading...</div>; 
    }

   
    const updatedData = {
        ...data,
        datasets: [
            {
                ...data.datasets[0],
                data: [totalEnquiries,  totalRegisteredStudents, totalEnrolledStudents], // Use the dynamic value for Total Enquiries
            },
        ],
    };

    return (
        <>
            <Doughnut data={updatedData} options={options} />
        </>
    );
};

export default DonutChart;
